import { Injectable } from '@angular/core';
import {UserInfo} from './model/UserInfo';
import { HttpClient } from '@angular/common/http';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AisCommonService {

  private userInfo: UserInfo = null;

  public userInfoSubject = new Subject<UserInfo>();

  constructor(
    private http: HttpClient
  ) { }

  fetchUserInfo() {
    if (this.userInfo !== null) {
      this.userInfoSubject.next(this.userInfo);
    }
    this.http
      .get<UserInfo>('/ais/rest/portal/users/info')
      .subscribe((data) => {
        this.userInfo = data;
        this.userInfoSubject.next(this.userInfo);
      });
  }

}
